<template>
  <v-container>
    <v-layout>
      <v-flex xs12 sm6 offset-sm3>
        <v-card>
          <v-card-title>
            <h3>Create your password:</h3>
          </v-card-title>
          <v-card-text>
            <content-field
              name="password"
              :label="passwordLabelText"
              type="password"
              v-model="password"
              :error="$v.password"
            />
            <content-field
              name="Confirm password"
              :label="repeatPasswordLabelText"
              type="password"
              v-model="repeatPassword"
              :error="$v.repeatPassword"
            />
            <v-btn
              color="info"
              :disabled="$v.$invalid"
              @click="submitPassword"
            >
              Submit
            </v-btn>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import ContentField from '@/components/shared/ContentField'
import { required, sameAs, minLength } from 'vuelidate/lib/validators'

export default {
  name: 'password-setting',
  components: { ContentField },
  data () {
    return {
      password: '',
      repeatPassword: '',
      token: ''
    }
  },
  computed: {
    repeatPasswordLabelText () {
      return this.$v.repeatPassword.$dirty && !this.$v.repeatPassword.sameAsPassword? 'Passwords must be identical' : 'Confirm password'
    },
    passwordLabelText () {
    let pattern = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{10,}$/
    return this.$v.password.$dirty && !pattern.test(this.password)? 'Min 10 characters, upper and lower case letters, numbers' : 'Password'
    }
  },
  validations: {
      password: {
        required,
        minLength: minLength(10)
      },
    repeatPassword: {
        required,
        sameAsPassword: sameAs('password')
      }
  },
  methods: {
    ...mapActions([
      'showResultErrorMessage',
      'submitNewPassword'
    ]),
    async submitPassword () {
      try {
        const payload  = {
          token: encodeURIComponent(this.token),
          newPassword: this.password
        }
        await this.submitNewPassword(payload)
        this.password = ''
        this.repeatPassword = ''
        this.token = ''
        this.$router.push({ path: '/login' })
      } catch (err) {
        console.error(err)
      }
    },
    checkTokenExist () {
      if (!this.token) {
        this.showResultErrorMessage('No token. Check if your link contains token')
      }
    }
  },
  created () {
    this.token = this.$route.query.token
    this.checkTokenExist()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/PasswordSetting/index.vue